<template>
  <v-card flat>
    <v-card-title class="pa-0" v-if="stepTitle">
      <v-toolbar card dark color="primary" height="36px">
        <h5>{{ stepTitle }}</h5>
      </v-toolbar>

      <v-divider></v-divider>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row justify-space-between align-center px-2 py-2 v-if="fetched">
        <pdfStep
          v-if="step.step_template.action_type === 'edit_pdf'"
          :step="step"
          :action-done.sync="actionDone"
        />
        <inputStep
          v-if="step.step_template.action_type === 'fill_field'"
          :step="step"
          :action-done.sync="actionDone"
        />
        <emailStep
          :expeditionId="expeditionId"
          v-if="step.step_template.action_type === 'send_email'"
          :step="step"
          :action-done.sync="actionDone"
        />
        <uploadStep
          v-if="step.step_template.action_type === 'upload_file'"
          :step="step"
          :action-done.sync="actionDone"
        />
        <validationStep
          v-if="step.step_template.action_type === 'validate_field'"
          :step="step"
          :action-done.sync="actionDone"
        />
      </v-layout>
      <v-layout row justify-center align-center pa-4 v-if="!fetched">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        flat
        v-if="!step.validated"
        :loading="loading"
        @click.prevent="validateStep()"
        color="success"
      >
        <v-icon class="ma-2" small color flat>check_circle_outline</v-icon>
        <div>Confirm step validation</div>
      </v-btn>

      <v-btn
        flat
        :disabled="actionDone"
        v-if="step.validated"
        :loading="loading"
        @click.prevent="cancelStep()"
        color="error"
      >
        <v-icon class="ma-2" small color flat>highlight_off</v-icon>Cancel step
        validation
      </v-btn>

      <v-btn flat color="error" @click="$emit('closeModale')">
        <v-icon class="ma-2" small color flat>highlight_off</v-icon>
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SHOW_STEP from "../../graphql/steps/show_step.gql";
import RELOAD_STEP from "../../graphql/steps/reload_step.gql";
import VALIDATE_STEP from "../../graphql/steps/validate_step.gql";
import inputStep from "./inputStep";
import emailStep from "./emailStep";
import uploadStep from "./uploadStep";
import validationStep from "./inputStep";
import pdfStep from "./pdfStep";
import { mapGetters } from "vuex";

export default {
  components: {
    inputStep,
    emailStep,
    uploadStep,
    validationStep,
    pdfStep,
  },
  props: {
    stepTitle: {
      type: String,
      required: false,
      default: "",
    },
    noScroll: {
      type: Boolean,
      required: false,
    },
    expeditionId: {
      type: String,
      required: false,
    },
    stepId: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
    inModale: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  name: "stepCard",
  data() {
    return {
      step: {},
      loading: false,
      actionDone: false,
    };
  },
  computed: {
    ...mapGetters("contractStore", ["contract"]),
    fetched() {
      if (!this.step) return false;
      return this.stepId === this.step.id;
    },
  },
  methods: {
    onStepValidated() {
      if (this.expeditionId) {
        this.$set(
          this.contract.expeditions
            .find((e) => e.id == this.expeditionId)
            .steps.find((s) => s.id == this.step.id),
          "validated",
          true
        );
        this.$set(
          this.contract.expeditions
            .find((e) => e.id == this.expeditionId)
            .steps.find((s) => s.id == this.step.id),
          "updated_at",
          new Date()
        );
      }
      this.step.validated = true;
      this.loading = false;
      this.actionDone = false;
      this.$emit("stepValidated", true);
    },
    validateStep() {
      this.loading = true;
      this.sendMutation("validated", "step", VALIDATE_STEP, {
        id: this.step.id,
        validated: true,
      })
        .then((data) => {
          this.onStepValidated();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cancelStep() {
      this.loading = true;
      this.sendMutation("canceled", "step", VALIDATE_STEP, {
        id: this.step.id,
        validated: false,
      })
        .then(() => {
          this.step.validated = false;
          this.loading = false;
          this.actionDone = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchStep() {
      this.fetchAndSubscribe(
        SHOW_STEP,
        { id: this.stepId },
        "contractStore",
        "step"
      ).then((data) => {
        this.step = data.step;
        if (this.open) {
          setTimeout(() => {
            this.scrollToThisStep();
          }, 400);
        }
      });
    },
    scrollToThisStep() {
      if (this.noScroll) return;
      this.$vuetify.goTo("#step__" + this.stepId, {
        duration: 500,
        offset: 8,
        easing: "easeInOutCubic",
      });
    },
  },
  watch: {
    open() {
      if (!this.open) return;

      if (this.step.id == this.stepId) {
        setTimeout(() => {
          this.scrollToThisStep();
        }, 700);
        return;
      }

      this.fetchStep();
    },
    stepId() {
      if (!this.open) return;

      if (this.step.id == this.stepId) return;

      this.fetchStep();
    },
  },
};
</script>
<style lang="stylus" scoped>
.stepTitle {
  color: var(--v-secondary-base);
}
</style>
